import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-dialog-change-original-linear',
  templateUrl: './dialog-change-original-linear.component.html',
  styleUrls: ['./dialog-change-original-linear.component.scss']
})
export class DialogChangeOriginalLinearComponent {
  @ViewChild('confirmRecordIdDialog') confirmRecordIdDialog: ModalDirective;

  @Input() recordId: string;
  @Input() canMarkInternal: boolean;

  @Output() onConfirm = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  public show(): void {
    this.confirmRecordIdDialog.show();
  }

  public confirm(): void {
    this.confirmRecordIdDialog.hide();
    this.onConfirm.emit();
  }

  public cancel(): void {
    this.confirmRecordIdDialog.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/locations/details/linear/change-original-linear/dialog-change-original-linear.component.ts